import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

// Sticky "you have unsaved changes" bar with Save / Discard.
export function UnsavedBar({ show, saving, onSave, onDiscard }) {
  if (!show) return null;
  return (
    <div className="sticky bottom-4 z-30 mt-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-accent/40 bg-card/95 px-4 py-3 shadow-lift backdrop-blur"
      data-testid="unsaved-bar">
      <span className="text-sm font-medium text-foreground">You have unsaved changes.</span>
      <div className="flex items-center gap-2">
        <Button variant="ghost" onClick={onDiscard} disabled={saving} data-testid="unsaved-discard">Discard</Button>
        <Button onClick={onSave} disabled={saving} data-testid="unsaved-save">
          {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Save changes
        </Button>
      </div>
    </div>
  );
}
